import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

//  正確匯入 Vuetify 實例
import vuetify from './plugins/vuetify.js'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

//  vue-loading-overlay
import { LoadingPlugin } from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/css/index.css'

//  axios 設定
import axios from 'axios'
axios.defaults.withCredentials = true
store.dispatch('initializeStore')

//  建立 App 實例，正確掛載 Vuetify
createApp(App)
    .use(store)
    .use(router)
    .use(LoadingPlugin)
    .use(vuetify)
    .mount('#app')